import React, { useState, useEffect } from 'react';
// import backicon from "./../../../../../Assets/icons/backicon.svg";
import backicon from '../../../../../Assets/icons/backIcon.svg';
import cancelCsv from './../../../../../Assets/icons/cancelCsv.svg';
import './AddStockIn.scss';
import { useNavigate } from 'react-router-dom';
// import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import 'react-toastify/dist/ReactToastify.css';
// import axiosInstance from "../../../../../services/api/API";
// import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
// import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
// import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from '../../../../customComponents/CustomSweetAlert/ShowAlert';
import Loader from '../../../../customComponents/CustomLoader';
import axiosInstance from '../../../../services/api/API';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import validations from '../../../../../helpers/validations';
import { buttonStyle, isFormValid } from '../../../../../helpers/common';

// import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";

const AddStockInSales = () => {
  // const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [userTypedd, setUserTypedd] = useState([]);
  const [variantOptions, setVariantOptions] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');
  const [dealerOption, setDealerOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);

  const userType = localStorage.getItem('UserType');
  const businessPartnerId = localStorage.getItem('businessPartnerId');
  const dealerId = localStorage.getItem('dealerId');

  const [formData, setFormData] = useState({
    itemTypebulk: '',
    variantIds: [],
    itemIds: [],
    quantity: '',
  });

  const [bulkList, setBulkList] = useState([]);
  const [sampleDownloaded, setSampleDownloaded] = useState(false);
  const [isAddDisabled, setIsAddDisabled] = useState(false);

  const handleModalClose = () => {
    setShowModal(false);
    setFormData({});
  };

  const handleModalOpen = () => {
    setShowModal(true);
  };

  // whenever user changes the form, allow Add button again
  useEffect(() => {
    // consider form non-empty if any of these fields has a value
    const { itemTypebulk, variantIds = [], itemIds = [], quantity } = formData;
    if (
      itemTypebulk ||
      variantIds.length > 0 ||
      itemIds.length > 0 ||
      (quantity && quantity !== '')
    ) {
      setIsAddDisabled(false);
    }
  }, [formData]);

  useEffect(() => {
    const modelId = formData?.modelId;
    const dealerId = formData?.dealerId;
    if (modelId && dealerId) {
      fetchVariantOptions(modelId, dealerId);
    }
  }, [formData?.modelId, formData?.dealerId]);

  const fetchVariantOptions = async (modelId, dealerId) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        { model_id: modelId, dealer_id: dealerId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post('/dealer/ddldealer', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));

      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchItemOptions();
  }, []);

  const fetchItemOptions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitem',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  const handleFormSubmit = async (formData) => {
    console.log('productformdata', formData);

    // Validate form before submission
    const errors = {};
    let isValid = true;

    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await showAlert({
      title: 'Confirmation',
      text: 'Are you sure you want to add this item to stock?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      // const payload = {
      //   quantity: formData.quantity,
      //   item_id:
      //     formData.itemType === "V" ? formData.variant : formData.accessory,
      // };

      const typeMap = {
        V: 3, // Vehicle
        S: 1, // Spare Part
        A: 2, // Accessories
      };

      const payload = {
        quantity: formData.quantity,
        // itemtype_id: formData.itemType,
        itemtype_id: typeMap[formData.itemType] ?? null,
        ...(formData.itemType === 'V'
          ? { variant_id: formData.variant }
          : { item_id: formData.accessory }),
      };

      const response = await axiosInstance.post('/inStock/add-stock', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log('API Response:', response.data);

      if (response.status === 200) {
        await showAlert({
          title: 'Success',
          text: 'Item added to stock successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        navigate('/admin/manage-product/stock-in');
      }
    } catch (error) {
      console.error('Error submitting form:', error);

      const errorMessage =
        error.response?.data?.message ||
        'An error occurred while processing your request.';
      await showAlert({
        title: 'Something went wrong',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
      setLoading(false);
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  // const handleDownload = async (formData) => {
  //   console.log("productformdata", formData);

  //   // Validate form before submission
  //   const errors = {};
  //   let isValid = true;

  //   BulkUploadInputs.forEach((field) => {
  //     if (field.validation && field.validation.required) {
  //       if (!formData[field.name]) {
  //         errors[field.name] = "This field is required";
  //         isValid = false;
  //       } else if (
  //         field.required &&
  //         field.validation &&
  //         field.validation.pattern &&
  //         !field.validation.pattern.test(formData[field.name])
  //       ) {
  //         errors[field.name] = field.validation.message;
  //         isValid = false;
  //       }
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     return;
  //   }
  //   const confirmation = await showAlert({
  //     title: "Confirmation",
  //     text: "Are you sure you want to download?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (!confirmation.isConfirmed) {
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const payload = {
  //       variantIds: formData.variantIds || [],
  //       itemIds: formData.itemIds || [],
  //     };

  //     const response = await axiosInstance.post(
  //       "/instock/download-excell-sample",
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     console.log("API Response:", response.data);

  //     if (response.status === 200) {
  //       await showAlert({
  //         title: "Success",
  //         text: "Item added to stock successfully.",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //       // navigate("/admin/manage-product/stock-in");
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form:", error);

  //     const errorMessage =
  //       error.response?.data?.message ||
  //       "An error occurred while processing your request.";
  //     await showAlert({
  //       title: "Something went wrong",
  //       text: errorMessage,
  //       confirmButtonText: "OK",
  //     });
  //     setLoading(false);
  //   } finally {
  //     setLoading(false); // Hide loading state
  //   }
  // };

  // const handleDownload = async (formData) => {
  //   try {
  //     const payload = {
  //       variantIds: formData.variantIds || [],
  //       itemIds: formData.itemIds || [],
  //     };

  //     const response = await axiosInstance.post(
  //       `/instock/accept-instock-dealer-quantity/${dealerId}`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //         responseType: "blob", // Set response type to blob for file downloads
  //       }
  //     );

  //     // Create a URL for the file blob
  //     const url = window.URL.createObjectURL(new Blob([response.data]));

  //     // Create a link element
  //     const link = document.createElement("a");
  //     link.href = url;

  //     // Set the file name for the download to .csv
  //     link.setAttribute("download", "sample.csv"); // Changed to .csv

  //     // Append the link to the body (required for some browsers)
  //     document.body.appendChild(link);

  //     // Programmatically trigger the click event on the link
  //     link.click();

  //     // Clean up the link after download
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async () => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));
      console.log(options, 'responseVal');

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  const handleDownload = async (formData) => {
    console.log(formData, 'formdataaaaa>>>>');
    try {
      // const dealer_Id = formData?.dealerId
      console.log('FULL formData:', formData);
      console.log('dealerId raw:', formData?.dealerId);
      console.log('dealerId value:', formData?.dealerId?.value);

      const uploadQuantityData = [];

      const variantTypeMap = {
        V: 3, // Vehicle
        A: 2, // Accessories
        S: 1, // Spare Part
      };

      if (!bulkList || bulkList.length === 0) return;

      bulkList.forEach((row) => {
        const variantTypeId = variantTypeMap[row.itemTypebulk]; // convert V/A/S → number

        if (!variantTypeId || !row.quantity) return;

        // For Vehicle
        if (row.itemTypebulk === 'V' && row.variantIds?.length > 0) {
          row.variantIds.forEach((variantId) => {
            uploadQuantityData.push({
              variantTypeId,
              variantId,
              itemId: null,
              quantity: Number(row.quantity),
            });
          });
        }

        // For Accessories or Spare Part
        if (
          (row.itemTypebulk === 'A' || row.itemTypebulk === 'S') &&
          row.itemIds?.length > 0
        ) {
          row.itemIds.forEach((itemId) => {
            uploadQuantityData.push({
              variantTypeId,
              variantId: null,
              itemId,
              quantity: Number(row.quantity),
            });
          });
        }
      });

      if (uploadQuantityData.length === 0) return;

      const payload = { uploadQuantityData };

      const response = await axiosInstance.patch(
        `/instock/accept-instock-dealer-quantity/${formData?.dealerId}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          responseType: 'blob',
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'sample.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.log('Download Error:', error);
    }
  };

  const getBulkUploadInputs = (data) => [
    {
      name: 'itemTypebulk',
      label: 'Item Type',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    ...(data.itemTypebulk === 'V'
      ? [
          {
            name: 'variantIds',
            label: 'Variant',
            type: 'multiselectdropdown',
            options: variantOptions,
            gridClass: 'col-lg-3',
          },
        ]
      : []),
    ...(data.itemTypebulk !== 'V'
      ? [
          {
            name: 'itemIds',
            label: 'Item Name',
            type: 'multiselectdropdown',
            options: accessoryOptions,
            gridClass: 'col-lg-3',
          },
        ]
      : []),
    {
      name: 'quantity',
      label: 'Quantity',
      type: 'text',
      required: true,
      gridClass: 'col-lg-3',
      validation: validations.quantity({ required: true }),
    },
  ];

  const CustomerInputs = [
    {
      name: 'dealerId',
      label: 'Dealer ',
      placeholder: 'Select Dealer',
      type: 'dropdown',
      options: dealerOption,
      // required: true,
      gridClass: 'col-lg-5',
    },
    {
      name: 'itemType',
      label: 'Item Type',
      placeholder: 'Enter',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    ...(formData.itemType === 'V'
      ? [
          {
            // name: "variant",
            name: 'variant',
            label: 'Variant',
            placeholder: '',
            type: 'dropdown',
            options: variantOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemType !== 'V'
      ? [
          {
            name: 'accessory',
            label: 'Item Name',
            placeholder: '',
            type: 'dropdown',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    {
      name: 'quantity',
      label: 'Quantity',
      placeholder: 'Enter Quantity',
      type: 'number',
      required: true,
      validation: validations.quantity({ required: true }),
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "toggle",
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "productimage",
    //   label: "Upload Product Brochure",
    //   type: "productfile",
    //   required: true,
    //   gridClass: "col-lg-6",
    //   validation: { required: true },
    // },
  ];

  const BulkUploadInputs = [
    {
      name: 'dealerId',
      label: 'Dealer ',
      placeholder: 'Select Dealer',
      type: 'dropdown',
      options: dealerOption,
      required: true,
      gridClass: 'col-lg-3',
    },
    {
      name: 'itemTypebulk',
      label: 'Item Type',
      placeholder: 'Enter',
      type: 'dropdown',
      options: [
        { value: 'V', label: 'Vehicle' },
        // { value: "A", label: "Accessories" },
        { value: 'S', label: 'Spare Part' },
      ],
      required: true,
      gridClass: 'col-lg-3',
      validation: { required: true },
    },
    ...(formData.itemTypebulk === 'V'
      ? [
          {
            // name: "variant",
            name: 'modelId',
            label: 'Model',
            placeholder: 'Select Model',
            type: 'dropdown',
            options: modelOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true }
          },
          {
            // name: "variant",
            name: 'variantIds',
            label: 'Variant',
            placeholder: '',
            type: 'multiselectdropdown',
            options: variantOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    ...(formData.itemTypebulk !== 'V'
      ? [
          {
            name: 'itemIds',
            label: 'Item Name',
            placeholder: '',
            type: 'multiselectdropdown',
            options: accessoryOptions,
            required: true,
            gridClass: 'col-lg-3',
            validation: { required: true },
          },
        ]
      : []),
    {
      name: 'quantity',
      label: 'Quantity',
      placeholder: 'Enter Quantity',
      type: 'number',
      required: true,
      gridClass: 'col-lg-3',
      validation: validations.quantity({ required: true }),
      // validation: {
      //   required: true,
      //   pattern: /^[1-9][0-9]*$/,
      //   message: "Please enter a positive number with no leading zeros",
      // },
    },
  ];

  const UploadInputs = [
    // {
    //   name: "bulksrnoUpload",
    //   label: " ",
    //   type: "file",
    //   required: true,
    //   gridClass: "col-lg-6",
    //   //validation:{required:true}
    // },
    {
      name: 'bulksrnoUpload',
      label: 'Upload Stock In',
      type: 'file',
      // allowedExtensions: ["csv", "xlsx"],
      required: true,
      gridClass: 'col-lg-4',
      // validation: { required: true },
      validation: {
        required: true,
        allowedExtensions: ['csv'], // Dynamically accepts only CSV
        maxSizeMB: 10,
      },
    },
  ];

  const DamagedInputs = () => {
    console.log('damagedformdata', formData);

    // if (orderformData?.length > 0) {
    return (
      <div className="mb-3">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
          className="col-lg-12"
        >
          <div>
            <DynamicForm
              formConfig={UploadInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
        </div>
      </div>
    );
  };

  const handleFormSubmitBulk = async (formData) => {
    console.log('productformdata', formData);

    // Validate form before submission
    const errors = {};
    let isValid = true;

    UploadInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = 'This field is required';
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await showAlert({
      title: 'Confirmation',
      text: 'Are you sure you want to add this item to stock?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    setLoading(true);

    try {
      // Create FormData and append the file
      const payload = new FormData();
      payload.append('bulksrnoUpload', formData.bulksrnoUpload);

      const response = await axiosInstance.patch(
        // `/instock/accept-instock-dealer/${dealerId}`,
        `/instock/accept-instock-dealer/${formData?.dealerId}`,
        payload,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      console.log('API Response:', response.data);

      if (response.status === 200) {
      
setShowModal(false)
        await showAlert({
          title: 'Success',
          text: 'Item added to stock successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        navigate("/sales/manage-product/stock-in");
      }
    } catch (error) {
  console.error('Error submitting form:', error);

  let errorMessage = 'An error occurred while processing your request.';

  if (error.response) {
    const { data } = error.response;

    // ✅ PRIORITY 1: Row-level errors
    if (Array.isArray(data?.data) && data.data.length > 0) {
      errorMessage = data.data
        .map(
          (err) =>
            `Row ${err.message}`
        )
        .join('\n\n');
    }

    // ✅ PRIORITY 2: fallback message ONLY if no row errors
    else if (data?.message) {
      errorMessage = data.message;
    }
  }

  // ✅ Network / unknown errors
  else if (error.message) {
    errorMessage = error.message;
  }

  await showAlert({
    title: 'Something went wrong',
    text: errorMessage,
    icon: 'error',
    confirmButtonText: 'OK',
  });
      setLoading(false);
    }finally {
      setLoading(false); // Hide loading state
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2" >
              <img src={backicon} alt="back" onClick={() => navigate(-1)}/>
              <span className="backbtntitle">Add Stock In</span>
            </div>
            {/* Bulk Upload Section */}
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Bulk Upload Stock In
              </span>
              <DynamicForm
                formConfig={BulkUploadInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />

              <div className="table-responsive mt-4">
                <table className="table table-bordered table-striped align-middle custom-bulk-table">
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: '18%' }}>Item Type</th>
                      <th style={{ width: '62%' }}>Variant / Item Name</th>
                      <th style={{ width: '15%' }}>Quantity</th>
                    </tr>
                  </thead>

                  <tbody>
                    {bulkList.length === 0 ? (
                      <tr>
                        <td colSpan="3" className="text-center text-muted py-3">
                          No items added yet
                        </td>
                      </tr>
                    ) : (
                      bulkList.map((row, i) => (
                        <tr key={i}>
                          <td>
                            {row.itemTypebulk === 'V'
                              ? 'Vehicle'
                              : row.itemTypebulk === 'A'
                                ? 'Accessories'
                                : 'Spare Part'}
                          </td>

                          {/* <td>
              {(row.itemTypebulk === "V" ? row.variantIds : row.itemIds)?.join(", ")}
            </td> */}
                          <td>
                            {row.itemTypebulk === 'V'
                              ? row.variantIds
                                  .map(
                                    (id) =>
                                      variantOptions?.find(
                                        (option) => option.value === id,
                                      )?.label,
                                  )
                                  .join(', ')
                              : row.itemIds
                                  .map(
                                    (id) =>
                                      accessoryOptions?.find(
                                        (option) => option.value === id,
                                      )?.label,
                                  )
                                  .join(', ')}
                          </td>

                          <td className="text-center fw-semibold">
                            {row.quantity}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {/* {formDataList.map((data, index) => (
                <DynamicForm
                  key={index}
                  formConfig={getBulkUploadInputs(data)}
                  formData={data}
                  setFormData={(updatedData) => {
                    const newList = [...formDataList];
                    newList[index] = updatedData;
                    setFormDataList(newList);
                  }}
                />
              ))} */}

              <div className="btncontainer mt-3">
                {/* <button className="submit-btn"
                  style={{ marginRight: "16px" }}>
                Add
              </button> */}
                {/* <button
                  className="submit-btn"
                  style={{ marginRight: "16px" }}
                  onClick={() => {
                    setBulkList([...bulkList, formData]); // store current row

                    // reset the form
                    // setFormData({
                    //   itemTypebulk: "",
                    //   variantIds: [],
                    //   itemIds: [],
                    //   quantity: "",
                    // });
                    setFormData((prev) => ({
                      ...prev, // keep dealerId
                      itemTypebulk: "",
                      variantIds: [],
                      itemIds: [],
                      quantity: "",
                    }));
                  }}
                >
                  Add
                </button> */}
                <button
                  className="submit-btn"
                  disabled={
                    isAddDisabled ||
                    !isFormValid(
                      BulkUploadInputs,
                      formData,
                      validationErrors,
                    ) ||
                    loading
                  }
                  style={{...buttonStyle(
                    BulkUploadInputs,
                    formData,
                    validationErrors,
                    loading,
                  ), marginRight: "16px" }}
                  onClick={async () => {
                    // validate current row before adding
                    const {
                      itemTypebulk,
                      variantIds = [],
                      itemIds = [],
                      quantity,
                    } = formData;
                    let valid = true;

                    if (!itemTypebulk || !quantity) {
                      valid = false;
                    } else if (
                      itemTypebulk === 'V' &&
                      variantIds.length === 0
                    ) {
                      valid = false;
                    } else if (itemTypebulk !== 'V' && itemIds.length === 0) {
                      valid = false;
                    }

                    if (!valid) {
                      await showAlert({
                        title: 'Missing data',
                        text: 'Please select item type, choose at least one variant/item and enter quantity before adding.',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                      });
                      return;
                    }

                    setBulkList([...bulkList, formData]); // store current row
                    setIsAddDisabled(true);

                    // reset the form, but retain dealerId
                    setFormData((prev) => ({
                      ...prev, // keep dealerId
                      itemTypebulk: '',
                      variantIds: [],
                      itemIds: [],
                      quantity: '',
                    }));
                  }}
                >
                  Add
                </button>
              </div>
              <div className="btncontainer mt-3">
                <button
                  onClick={async () => {
                    if (bulkList.length === 0) {
                      await showAlert({
                        title: 'No items added',
                        text: 'Please add at least one item before downloading the sample.',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                      });
                      return;
                    }
                    handleDownload(formData);
                    setSampleDownloaded(true);
                  }}
                  className="submit-btn"
                  style={{ marginRight: '16px' }}
                >
                  Download Sample
                </button>
                <button
                  onClick={async () => {
                    if (!sampleDownloaded) {
                      await showAlert({
                        title: 'Sample not downloaded',
                        text: 'Please download the sample before uploading.',
                        icon: 'warning',
                        confirmButtonText: 'OK',
                      });
                      return;
                    }
                    handleModalOpen();
                  }}
                  className="submit-btn"
                >
                  Upload
                </button>
              </div>
            </div>

            {showModal && (
              <div className="custom-modal-overlay">
                <div className="custom-modal-itemDetails-modal">
                  <div className="custom-modal-header">
                    <h6 style={{ fontSize: '24px', fontWeight: '600' }}>
                      Update Quantity
                    </h6>
                    <button
                      className="close-button"
                      style={{ width: '24px', height: '24px' }}
                      onClick={handleModalClose}
                    >
                      <img
                        src={cancelCsv}
                        alt="cancelCsv"
                        height={24}
                        width={24}
                      />
                    </button>
                  </div>

                  <div className="custom-modal-body-itemDetails">
                    <table
                      style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                      <tbody>
                        <tr style={{ borderBottom: '1px solid lightgray' }}>
                          <td style={{ padding: '10px', fontSize: '14px' }}>
                            {/* Assuming DamagedInputs is a function rendering the file input */}
                            {DamagedInputs()}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="custom-modal-footer">
                    <button
                      className="submit-btn"
                      disabled={
                        !isFormValid(
                          UploadInputs,
                          formData,
                          validationErrors,
                        ) || loading
                      }
                      style={buttonStyle(
                        UploadInputs,
                        formData,
                        validationErrors,
                        loading,
                      )}
                      onClick={() => handleFormSubmitBulk(formData)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AddStockInSales;
